import { AffiliateLead, AffiliateLeadAdapter } from "@core/domain/affiliate-lead/affiliate-lead";

const AFFILIATE_COOKIE_KEY = "affiliate_lead";
const COOKIE_MAX_AGE = 2600000;

const isBrowser = typeof document !== "undefined";

export const affiliateLeadAdapter = (): AffiliateLeadAdapter => {
  const save = (affiliateLead: AffiliateLead): void => {
    if (!isBrowser) {
      return;
    }

    const cookieValue = encodeURIComponent(JSON.stringify(affiliateLead));
    document.cookie = `${AFFILIATE_COOKIE_KEY}=${cookieValue}; path=/; max-age=${COOKIE_MAX_AGE}`;
  };

  const get = (): AffiliateLead | null => {
    if (!isBrowser) {
      return null;
    }

    const cookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${AFFILIATE_COOKIE_KEY}=`));

    if (!cookie) {
      return null;
    }

    try {
      const cookieValue = decodeURIComponent(cookie.split("=")[1]);
      const affiliateLead = JSON.parse(cookieValue) as AffiliateLead;

      return affiliateLead;
    } catch (error) {
      return null;
    }
  };

  return {
    save,
    get,
  };
};
